function initSidebarToggle() {
	$('.sidebar__toggle').on('click', function(e) {
		$(this).toggleClass('open');
		$('.sidebar__drawer').toggleClass('open');
	});
}

function initMainNav() {
	$('.nav-main__toggle').on('click', function(e) {
		if ( $(window).width() < 992 ) {
			e.preventDefault();
			$('body').toggleClass('nav-main--opened');
		}
	});

	$('.nav-main__toggle').on('mouseenter', function(e) {
		if ( $(window).width() > 991 ) {
			setTimeout( function(){
				$('body').removeClass('header-is-hidden');
			}, 100 );
			setTimeout( function(){
				$('body').removeClass('header-is-blocked');
			}, 400 );
		}
	});

	$('.header-main').on('mouseleave', function(e) {
		if ( $(window).width() > 991 && $(window).scrollTop() > $(".header-main").outerHeight() ) {
			setTimeout( function(){
				$('body').addClass('header-is-hidden header-is-blocked');
			}, 100 );
		}
	});

	$('.nav-main__side a, .nav-main__specific a').on('click', function(e) {
		var linkUrl = $(this).attr('href');

		if ( linkUrl == window.location.href) {
			e.preventDefault();
			$('body').removeClass('nav-main--opened');
		}
	});
}

function initLocalScroll() {
	if ($('.localscroll').length > 0) {
		$('.localscroll').localScroll({
			hash: true
		});
		$.localScroll.hash();
	}
}

function initToggleNote() {
	$('.note-toggle').on('click', function (e) {
		e.preventDefault();
		target = $(this).closest('.note').find('.note-hidden');
		target.toggleClass('shown');
	});

	$('.note-hidden .close').on('click', function (e) {
		e.preventDefault();
		target = $(this).closest('.note').find('.note-hidden');
		target.toggleClass('shown');
	});
}